import { HStack, Text, Skeleton } from 'native-base';
import { FlairType } from '@breakroom-nx/helpers';

// Components
import { UserAvatar } from '../../';

// Assets
import { theme } from '@breakroom-nx/assets';
import { Flair } from '@breakroom-nx/classes';
import { RoomMember } from '@breakroom-nx/helpers';

export interface UserGroupProps {
  borderColor?: string;
  members?: RoomMember[];
  size?: number;
  compressed: boolean;
  loading?: boolean;
}

export function UserGroup({
  borderColor = theme.colors.surface[100],
  members = [],
  size = 10,
  compressed = false,
  loading = true,
}: UserGroupProps) {
  const renderMembersInRoom = () => {
    var squeezeCounter = 0; // Figures out when to start squeezing avatars
    //  ^ Requires that members[] is sorted starting with flair-ed users

    // Sorts by pushing undefined flairs to end
    // and by FlairType index (descending based on flair value)
    // members.sort((a: RoomMember, b: RoomMember) => {
    //   return (
    //     Number(a.flair?.type === undefined) -
    //       Number(b.flair?.type === undefined) ||
    //     Object.keys(FlairType).indexOf(String(a.flair?.type)) -
    //       Object.keys(FlairType).indexOf(String(b.flair?.type)) ||
    //     +(a > b) ||
    //     -(a < b)
    //   );
    // });

    return members
      ? members.map((member: RoomMember, index: number) => {
          if (!member.flair) {
            squeezeCounter++;
          }
          return index < 5 ? (
            <UserAvatar
              disabled={false}
              uid={member.uid}
              key={member.uid}
              borderColor={borderColor}
              flair={member.flair}
              squeeze={compressed || squeezeCounter > 1}
              size={size}
              zIndex={members.length - index}
            />
          ) : null;
        })
      : null;
  };

  if (loading) {
    return (
      <Skeleton
        width={'30px'}
        height={'30px'}
        rounded="full"
        startColor={theme.colors.surface[300]}
      />
    );
  } else {
    return (
      <HStack alignItems={'center'} space={1}>
        <HStack space={0}>{renderMembersInRoom()}</HStack>
        <Text color="white" fontWeight={600} fontFamily={'body'} fontSize={14}>
          {members.length < 6 ? null : '+' + (members.length - 5)}
        </Text>
      </HStack>
    );
  }
}

// export default React.memo(UserGroup);
